module.exports = __webpack_public_path__ + "media/media/home/img8-cf9b4ef70008fe907ef726bad2711f52.png";